module.exports = __webpack_public_path__ + "static/pdfs/notices.20087a6b6c2dd627d835098f99036c90.pdf";